import React, { useCallback, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import 'moment/locale/ja'
import moment from 'moment'
import { db, functions } from '../../firebase/index'
import { makeStyles } from '@material-ui/styles'
import domains from '../utils/domains'
import domains2 from '../utils/domains2'

import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

import DateFnsUtils from '@date-io/date-fns'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import localeJa from 'date-fns/locale/ja'

import {
  Container,
  CssBaseline,
  Typography,
  Button,
  AppBar,
  Card,
  CardContent,
  FormControl,
  Grid,
  Toolbar,
  RadioGroup,
  Link,
  Radio,
  FormControlLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  TextField,
} from '@material-ui/core'

import { saveRequest } from '../../modules/app'

import PhoneIcon from '@material-ui/icons/Phone'
import MapIcon from '@material-ui/icons/Map'

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit">PLUM CONNECT .</Link> {new Date().getFullYear()}
    </Typography>
  )
}

function validateEmail(email) {
  const emailFilter = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/
  if (!emailFilter.test(email)) {
    return false
  }

  const check = domains.find((v) => email.indexOf(v) !== -1)
  if (check) return false

  return domains2.find((v) => email.indexOf(v) !== -1)
}

function validatePhone(phone) {
  const tel = phone.replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi, '')
  if (!tel.match(/^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/)) {
    return false
  } else {
    return true
  }
}

const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
}))

const AlbumMd = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const handleDateChange = (date) => {
    setDate(date)
    setFilteredBooks(
      books.filter(
        (book) => moment(book.start).format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD')
      )
    )
  }

  let id = window.location.pathname.split('/webbooks/albummd')[1]
  if (id !== '') {
    id = id.split('/')[1]
  } else {
    dispatch(push('/'))
  }

  const [accountId, setAccountId] = useState('')
  const [bookId, setBookId] = useState('')
  const [name, setName] = useState('')
  const [url, setUrl] = useState('')
  const [token, setToken] = useState('')
  const [cardTitle, setCardTitle] = useState('')
  const [cardBody, setCardBody] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [address, setAddress] = useState('')
  const [biko, setBiko] = useState('')
  const [books, setBooks] = useState([])
  const [mailSubject, setMailSubject] = useState('')
  const [mailText, setMailText] = useState('')
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [filteredBooks, setFilteredBooks] = useState([])

  const [selectedDate, setSelectedDate] = useState('')
  const [date, setDate] = useState(new Date())
  const [patName, setPatName] = useState('')
  const [patKana, setPatKana] = useState('')
  const [patAge, setPatAge] = useState('')
  const [patPhone, setPatPhone] = useState('')
  const [patEmail, setPatEmail] = useState('')
  const [buttonText, setButtonText] = useState('')
  const [redirect, setRedirect] = useState('')

  const [checked, setChecked] = useState([])

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value)
    const newChecked = [...checked]

    if (currentIndex === -1) {
      newChecked.push(value)
    } else {
      newChecked.splice(currentIndex, 1)
    }

    setChecked(newChecked)
  }

  const inputPatPhone = useCallback(
    (event) => {
      setPatPhone(event.target.value)
    },
    [setPatPhone]
  )

  const inputPatEmail = useCallback(
    (event) => {
      setPatEmail(event.target.value)
    },
    [setPatEmail]
  )

  const inputPatName = useCallback(
    (event) => {
      setPatName(event.target.value)
    },
    [setPatName]
  )

  const inputPatKana = useCallback((event) => {
    setPatKana(event.target.value)
  }, [])

  const inputPatAge = useCallback(
    (event) => {
      setPatAge(event.target.value)
    },
    [setPatAge]
  )

  const inputBiko = useCallback(
    (event) => {
      setBiko(event.target.value)
    },
    [setBiko]
  )

  const handleChange = (event) => {
    setSelectedDate(event.target.value)
    setBookId(event.target.name)
  }

  useEffect(() => {
    setLoading(true)
    if (id !== '') {
      db.collection('accounts')
        .doc(id)
        .get()
        .then((res) => {
          const data = res.data()
          if (data) {
            setAccountId(data.id)
            setName(data.name)
            setEmail(data.email)
            setPhone(data.phone)
            setAddress(data.address)
            setCardBody(data.cardBody)
            setCardTitle(data.cardTitle)
            setMailSubject(data.mailSubject)
            setMailText(data.mailText)
            setUrl(data.url)
            setToken(data.token)
            setList(data.list)
            setButtonText(data.buttonText)
            setRedirect(data.redirect)

            fetch(`${data.url}?limit=${data.limit}`, {
              headers: {
                Authorization: data.token,
              },
            })
              .then((res) => res.json())
              .then((books) => {
                setBooks(books)
                setLoading(false)
              })
          }
        })
    }
  }, [id])

  return (
    <div>
      {loading ? (
        <div>Loading...</div>
      ) : (
        <React.Fragment>
          <CssBaseline />
          <AppBar position="relative">
            <Toolbar>
              <Typography variant="h6" color="inherit" noWrap>
                {name}
              </Typography>
            </Toolbar>
          </AppBar>
          <main>
            <div className={classes.heroContent}>
              <Container maxWidth="sm">
                <ReactMarkdown
                  className="markdown-body"
                  rehypePlugins={[rehypeRaw]}
                  children={cardTitle}
                />

                <ReactMarkdown
                  className="markdown-body"
                  rehypePlugins={[rehypeRaw]}
                  children={cardBody}
                />

                <div className={classes.heroButtons}>
                  <Grid container spacing={2} justifyContent="center">
                    <Grid item>
                      <a href={`tel:${phone.replace(/-/g, '')}`} style={{ textDecoration: 'none' }}>
                        <Button color="primary" variant="contained" startIcon={<PhoneIcon />}>
                          電話をかける
                        </Button>
                      </a>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<MapIcon />}
                        onClick={() =>
                          window.open(
                            `https://maps.google.co.jp/maps?q=${encodeURIComponent(address)}`
                          )
                        }
                      >
                        地図を確認
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </Container>
            </div>
            <Container className={classes.cardGrid} maxWidth="md">
              <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={6}>
                  <Card className={classes.card}>
                    <CardContent>
                      <Typography>希望の予約日、時間を選択してください</Typography>
                      <div style={{ margin: 12 }}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeJa}>
                          <DatePicker
                            disableToolbar
                            variant="static"
                            format="yyyy/MM/dd"
                            margin="dense"
                            id="date-picker-inline"
                            label="対象日"
                            value={date}
                            onChange={handleDateChange}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                      <FormControl>
                        <RadioGroup name="webbooks" value={selectedDate} onChange={handleChange}>
                          {filteredBooks.length === 0 ? (
                            <p>対象日の予約時間はみつかりませんでした</p>
                          ) : (
                            <>
                              {filteredBooks.map((book) => (
                                <FormControlLabel
                                  key={book.id}
                                  name={book.id}
                                  value={book.start}
                                  control={<Radio />}
                                  label={`${moment(book.start).format('M月D日HH時mm分(ddd)')}`}
                                />
                              ))}
                            </>
                          )}
                        </RadioGroup>
                      </FormControl>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Card className={classes.card}>
                    <CardContent>
                      <Typography>現在の症状、お悩みをお選びください</Typography>
                      <div>複数選択可能</div>
                      <List>
                        {list.map((value) => {
                          const labelId = `checkbox-list-label-${value}`
                          return (
                            <ListItem
                              key={value}
                              role={undefined}
                              dense
                              button
                              onClick={handleToggle(value)}
                            >
                              <ListItemIcon>
                                <Checkbox
                                  edge="start"
                                  checked={checked.indexOf(value) !== -1}
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ 'aria-labelledby': labelId }}
                                />
                              </ListItemIcon>
                              <ListItemText id={labelId} primary={`${value}`} />
                            </ListItem>
                          )
                        })}
                      </List>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={6}>
                  <Card className={classes.card}>
                    <CardContent>
                      <Typography>その他、ご希望あれば入力してください</Typography>
                      <div>ご紹介がある場合、担当医変更希望など</div>
                      <TextField
                        margin="dense"
                        fullWidth
                        label="その他"
                        multiline
                        rows={5}
                        type="text"
                        value={biko}
                        onChange={inputBiko}
                      />
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Card className={classes.card}>
                    <CardContent>
                      <Typography>受診者について</Typography>
                      <div>実際に診療される方の情報を記載ください</div>
                      <TextField
                        margin="dense"
                        fullWidth
                        label="お名前"
                        required
                        type="text"
                        value={patName}
                        onChange={inputPatName}
                      />
                      <TextField
                        margin="dense"
                        fullWidth
                        label="ふりがな"
                        required
                        type="text"
                        value={patKana}
                        onChange={inputPatKana}
                      />
                      <TextField
                        margin="dense"
                        fullWidth
                        label="年齢"
                        required
                        type="text"
                        value={patAge}
                        onChange={inputPatAge}
                      />
                      <TextField
                        margin="dense"
                        fullWidth
                        label="電話番号"
                        required
                        type="text"
                        value={patPhone}
                        onChange={inputPatPhone}
                      />
                      <TextField
                        margin="dense"
                        fullWidth
                        label="Eメールアドレス"
                        required
                        type="text"
                        value={patEmail}
                        onChange={inputPatEmail}
                      />
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  padding: 40,
                }}
              >
                <Button
                  className={classes.submit}
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setError(null)
                    if (validatePhone(patPhone) && validateEmail(patEmail)) {
                      dispatch(
                        saveRequest(
                          accountId,
                          patName,
                          patKana,
                          patAge,
                          patPhone,
                          patEmail,
                          selectedDate,
                          biko
                        )
                      ).then((re) => {
                        if (re) {
                          fetch(`${url}/${bookId}`, {
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/json',
                              Authorization: token,
                            },
                            body: JSON.stringify({
                              name: patName,
                              kana: patKana,
                              age: patAge,
                              phone: patPhone,
                              email: patEmail,
                              memo: `${biko} ${checked.join()}`,
                            }),
                          })

                          const sendMail = functions.httpsCallable('sendMail')
                          const body = mailText
                            .replace(/{{name}}/g, patName)
                            .replace(/{{date}}/g, moment(selectedDate).format('YYYY-MM-DD HH:mm'))
                          sendMail({
                            to: patEmail,
                            subject: mailSubject,
                            text: body,
                          })
                            .then(() => {
                              console.log('ok')
                            })
                            .catch((error) => {
                              throw new Error(error)
                            })

                          const subject = 'WEB予約通知'
                          const text =
                            `医院名:${name}\n` +
                            `希望日時:${moment(selectedDate).format('YYYY-MM-DD HH:mm')}\n` +
                            `お名前:${patName}\n` +
                            `ふりがな:${patKana}\n` +
                            `年齢:${patAge}\n` +
                            `電話番号:${patPhone}\n` +
                            `メールアドレス:${patEmail}\n` +
                            `現在の症状:${checked.join()}\n` +
                            `その他:${biko}\n`

                          const msg = {
                            to: email,
                            subject: subject,
                            text: text,
                          }
                          sendMail(msg)
                            .then(() => {
                              dispatch(push(redirect))
                            })
                            .catch((error) => {
                              throw new Error(error)
                            })
                        }
                      })
                    } else {
                      setError('登録できませんでした。')
                    }
                  }}
                >
                  {buttonText}
                </Button>
                {error && <p style={{ color: 'red' }}>{error}</p>}
              </div>
            </Container>
          </main>
          <footer className={classes.footer}>
            <Copyright />
          </footer>
        </React.Fragment>
      )}
    </div>
  )
}

export default AlbumMd
